var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdl(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 2)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.037 18.663c-2.248-.82-3.918-3.04-4.03-5.51-.149-3.203 2.368-6.605 5.62-6.75C5.62 2.51 8.794 0 12.624 0s7.413 2.543 7.93 6.402c3.323.505 5.69 3.45 5.426 6.752-.195 2.438-1.77 4.465-3.934 5.353",
    stroke: "#000",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6 6)"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "#13D7BC",
    strokeWidth: 1.5,
    cx: 9.5,
    cy: 2.5,
    r: 1.75
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13D7BC",
    d: "M7.605 3.092l.86 1.229L4.37 7.189l-.86-1.23zM4.247 7.6l-.75 1.298 4.246 2.625.75-1.299z"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#13D7BC",
    strokeWidth: 1.5,
    cx: 2.5,
    cy: 7.5,
    r: 1.75
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#13D7BC",
    strokeWidth: 1.5,
    cx: 9.5,
    cy: 11.5,
    r: 1.75
  })), /*#__PURE__*/React.createElement("rect", {
    fill: "#000",
    transform: "rotate(1 13 23.75)",
    x: 3,
    y: 23,
    width: 20,
    height: 1.5,
    rx: 0.75
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdl);
export default __webpack_public_path__ + "static/media/EDL.2708912b.svg";
export { ForwardRef as ReactComponent };